var map = {
	"./ranking-shop-img.png": "4176",
	"./ranking1.png": "92db",
	"./ranking2.png": "4cab",
	"./ranking3.png": "0be6",
	"./ranking4.png": "da43",
	"./ranking5.png": "28f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2cf";